import React from "react";
import { Editor } from "slate";
import { useSlate } from "slate-react";
import {
  ElementType,
  Format,
  TextSize,
  Alignment,
  CustomText,
} from "../../types";
import {
  isBlockActive,
  isMarkActive,
  toggleBlock,
  toggleMark,
  toggleAlignment,
} from "../../utils/text";

interface ToolbarButtonProps {
  format: Format | ElementType;
  icon: React.ReactNode;
  isBlock?: boolean;
  value?: TextSize | Alignment;
  label?: string;
}

export const ToolbarButton = ({
  format,
  icon,
  isBlock = false,
  value,
  label,
}: ToolbarButtonProps) => {
  const editor = useSlate();
  let isActive = false;

  if (format === "align") {
    const marks = Editor.marks(editor) as CustomText | null;
    isActive = marks?.align === value;
  } else if (isBlock) {
    isActive = isBlockActive(editor, format as ElementType);
  } else {
    isActive = isMarkActive(editor, format as Format, value);
  }

  return (
    <button
      onMouseDown={(event) => {
        event.preventDefault();
        if (format === "align" && value) {
          toggleAlignment(editor, value as Alignment);
        } else if (isBlock) {
          toggleBlock(editor, format as ElementType);
        } else {
          toggleMark(editor, format as Format, value);
        }
      }}
      className={`p-2 mx-1 rounded transition-colors flex items-center ${
        isActive
          ? "bg-primary-100 text-primary-600 dark:bg-primary-900 dark:text-primary-400"
          : "text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
      }`}
      title={label}
    >
      {icon}
      {label && <span className="ml-1 text-xs">{label}</span>}
    </button>
  );
};
